import { Button } from 'components/atoms/Button';
import type { FC, ReactNode } from 'react';

interface SignInMethodButtonProps {
  label: string;
  icon: ReactNode;
  type?: 'button' | 'submit';
  onClick?: () => void;
  disabled?: boolean;
}

const SignInMethodButton: FC<SignInMethodButtonProps> = ({
  label,
  icon,
  type = 'button',
  onClick,
  disabled,
}) => (
  <Button
    structure="secondary"
    color="primary"
    type={type}
    onClick={onClick}
    disabled={disabled}
    className="!w-full h-12 !text-base flex items-center justify-center gap-3 !bg-primary-25 !border-primary-100 hover:!bg-primary-50 rounded-lg"
  >
    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
      {icon}
    </span>
    {label}
  </Button>
);

export default SignInMethodButton;
